export default __webpack_public_path__ + "static/media/logoh.9dd46585.png";